<template>
  <div class="ma-4" app>
    <v-container fluid class="full-height">
      <v-row>
        <v-col md="12">
          <SessionTable />
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<script>
// @ is an alias to /src
import SessionTable from "./Components/SessionTable.vue";
export default {
  name: "Home",
  components: {
    SessionTable
  },
  mounted() {
    this.$store.dispatch(
      "getSubscriptionSessions",
      this.$route.params.subscription_id
    );
  }
};
</script>
